import styled from 'styled-components';

const Base = styled.div`
  ${props => props.w && `width: ${props.w};`}
  ${props => props.fluid && 'width: 100%;'}
  ${props => props.minW && `min-width: ${props.minW};`}
  ${props => props.h && `height: ${props.h};`}
  ${props => props.minH && `min-height: ${props.minH};`}
  ${props => props.pd && `padding: ${props.pd};`}
  ${props => props.mg && `margin: ${props.mg};`}
  ${props => props.ta && `& span {text-align: ${props.ta};}`}
  ${props => props.ts && `& span { text-size: ${props.ts}; }`}
  ${props => props.bc && `background-color: ${props.bc};`}
  ${props => props.bd && `border: ${props.bd};`}
  ${props => props.br && `border-radius: ${props.br};`}
  ${props => props.bs && `box-shadow: ${props.bs};`}
  ${props => props.styles}
  @media (max-width: 1920px) { ${props => props.r1920} }
  @media (max-width: 1366px) { ${props => props.r1366} }
  @media (max-width: 1120px) { ${props => props.r1120} }
  @media (max-width: 1024px) { ${props => props.r1024} }
  @media (max-width: 768px) { ${props => props.r768} }
  @media (max-width: 720px) { ${props => props.r720} }
  @media (max-width: 640px) { ${props => props.r640} }
  @media (max-width: 500px) { ${props => props.r500} }
  @media (max-width: 320px) { ${props => props.r320} }
`;

export default Base;
